import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M84.493 38.319c3.448 0 6.888.927 10.121 2.842l331.239 191.166c9.187 5.294 10.176 14.098 10.176 17.631s-.989 12.328-10.176 17.631L94.614 458.846c-3.233 1.824-6.673 2.843-10.121 2.843-9.816 0-20.466-7.816-20.466-20.474l.023-382.423c0-12.665 10.566-20.473 20.443-20.473m0-38.311c-30.649 0-58.778 24.511-58.778 58.784v382.423C25.715 475.45 53.844 500 84.493 500c9.823 0 19.76-2.521 29.277-7.969l331.155-191.257c39.146-22.535 39.146-79.075 0-101.617L113.77 7.992C104.276 2.551 94.254 0 84.493 0z" }, null, -1)
  ])))
}
export default { render: render }